import {ComboboxGroup} from '@ariakit/react'
import {StyledAgendaSearchNoResultsWrapper} from '@/features/agenda/components/agenda-sidebar-search/style'
import {useTranslation} from '@/translations/i18n'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {AgendaSidebarSearchLoader} from '@/features/agenda/components/agenda-sidebar-search/AgendaSidebarSearchLoader'
import {ReactNode} from 'react'
import {ComboboxGroupLabel} from '@/components/ui/combobox-atoms/ComboboxAtoms'
import {Text} from '@/components/ui/text/Text'

interface AgendaSidebarSearchListProps<T> {
    isLoading: boolean
    isError: boolean
    items: T[] | undefined
    renderItem: (item: T) => ReactNode
    icon: ReactNode
    labelText: ReactNode
    errorMessage?: string
    noResultsMessage?: string
}

export const AgendaSidebarSearchList = <T,>({
    isLoading,
    isError,
    items,
    renderItem,
    icon,
    labelText,
    errorMessage,
    noResultsMessage
}: AgendaSidebarSearchListProps<T>) => {
    const {t} = useTranslation()

    return (
        <ComboboxGroup>
            <ComboboxGroupLabel>
                {icon}
                {labelText}
            </ComboboxGroupLabel>
            {isLoading ? (
                <AgendaSidebarSearchLoader />
            ) : isError ? (
                <StyledAgendaSearchNoResultsWrapper>
                    <InputHelpText error={errorMessage || t('errors:default')} />
                </StyledAgendaSearchNoResultsWrapper>
            ) : items && items.length > 0 ? (
                items.map(renderItem)
            ) : (
                <StyledAgendaSearchNoResultsWrapper>
                    <Text size="textMd" palette="neutral" shade="500">
                        {noResultsMessage || t('commons:no_results')}
                    </Text>
                </StyledAgendaSearchNoResultsWrapper>
            )}
        </ComboboxGroup>
    )
}
